// extracted by mini-css-extract-plugin
var _1 = "rT0YOeoAFyJtchfePv3D";
var _2 = "D27xnedc69hgoKbLCZFI";
var _3 = "wLfGZ0QbjQzXT3tZW9gS";
var _4 = "oetB9uNTco2yTvOdj6QY";
var _5 = "jCHS5y_dpwvC_095X3KG";
var _6 = "JrcIC9vsI1Bhrl5nYpig";
var _7 = "fvyNnMg6X_WmPzX5NCpA";
var _8 = "BslNguCVFKoBGjyf3S9e";
export { _1 as "clothingCard", _2 as "clothingCardBody", _3 as "clothingCardCode", _4 as "clothingCardCover", _5 as "clothingCardDescription", _6 as "clothingCardName", _7 as "clothingCardPrice", _8 as "clothingCardPriceSymbol" }
